import Footer1 from "../../../components/footer/Footer1";
import Header1 from "../../../components/headers/Header1";
import PropertyDetails2 from "../../../components/property-details/PropertyDetails2";
import Slider2 from "../../../components/property-details/Slider2";
import React, { useEffect, useState } from "react";
import { GetAllPropertyforWeb } from "../../../APIs/APIHelperforWeb";
import { useSnackbar } from "notistack";
import { useNavigate, useParams } from "react-router-dom";


import MetaComponent from "../../../components/common/MetaComponent";
import { isArray } from "chart.js/helpers";

export default function PropertyDetailsPageV2() {

  const [Title, setTitle] = React.useState("");
  const [Description, setDescription] = React.useState("");
  const [Keywords, setKeywords] = React.useState("");
  const [MetaImage, setMetaImage] = React.useState("");

  const metadata = {
    title: Title,
    description: Description,
    keywords: Keywords,
    url: window.location.href,
    siteName: "AskMeRealty",
    canonical: window.location.href,
    image: MetaImage,
  };
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const [AllProperties, setAllProperties] = React.useState([]);
  const [PropertyObject, setPropertyObject] = React.useState({});

  return (
    <>
      <MetaComponent meta={metadata} />
      <Header1 />
      <Slider2  setMetaImage={setMetaImage}/>
      <PropertyDetails2 setTitle={setTitle} setDescription={setDescription} setKeywords={setKeywords}  />
      <Footer1 />
    </>
  );
}
